import config from "./portfolio-config.json";

export const settings = config.settings;
export const greeting = config.greeting;
export const socialMediaLinks = config.socialMediaLinks;
export const skills = { data: config.skills };
export const competitiveSites = config.competitiveSites;
export const degrees = config.degrees;
export const certifications = config.certifications;
export const experience = config.experience;
export const projectsHeader = config.projectsHeader;
export const contactPageData = config.contactPageData;
